import {PropsWithChildren} from "react";

import './button.scss';
import {ButtonTypes} from "../../../constants/ui/types/ButtonTypes";

interface ButtonProps {
  type?: ButtonTypes,
  onClick: (e?: any) => void,
  disabled?: boolean,
  toggled?: boolean,
  className?: string
  id?: string
}

const ButtonKMQ = (props: PropsWithChildren<ButtonProps>) => {
  const {
    children,
    type = ButtonTypes.Primary,
    onClick,
    disabled,
    toggled,
    className,
    id
  } = props;

  return <button id={id} className={`btn btn-${type} ${disabled ? 'btn-disabled' : ''} 
          ${toggled ? 'btn-toggled' : ''} ${className ? className : ''}`}
                 disabled={disabled} onClick={onClick}>
    {children}
  </button>
}

export default ButtonKMQ;